// FAQ.js
import { useState, useRef, useEffect } from "react";
import SubHeader from "../components/SubHeader";
import "./FAQ.css";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);
  const data = {
    title: "FAQ",
    rows: [
      {
        title: "How do I know if therapy is right for me?",
        content: `Therapy can benefit anyone who is struggling with mental health challenges, life transitions, relationship issues, or simply seeking personal growth. If you're unsure if therapy is right for you, we encourage you to schedule a free consultation with us to discuss your concerns and determine if therapy is a good fit.`,
      },
      {
        title: "How often should I attend therapy sessions?",
        content:
          "The frequency of therapy sessions depends on your individual needs and goals. Some prefer weekly sessions, while others may benefit from bi-weekly or monthly appointments. Your therapist will work with you to create a schedule that fits your needs and lifestyle.",
      },
      {
        title: "How long are therapy sessions?",
        content: `Therapy sessions typically last 50 minutes to one hour, but the duration can vary depending on your needs and preferences. During your initial session, you and your therapist will discuss the optimal session length for you.`,
      },
      {
        title: "Can I choose my therapist?",
        content:
          "Yes, you can choose your therapist based on factors such as their expertise, availability, and personal preferences. We believe that a strong therapeutic relationship is essential for successful outcomes, so we encourage you to explore our therapist profiles and select the one who resonates with you.",
      },
      {
        title: "What can I expect from my first therapy session?",
        content:
          "Your first therapy session is an opportunity for you to discuss your concerns, goals, and expectations with your therapist. It is normal to feel nervous or uncertain during your first session, but rest assured that your therapist is there to support you every step of the way.",
      },
      {
        title: "How much does therapy cost?",
        content:
          "We offer individual online therapy sessions for KES 2000 per session. For physical therapy sessions, we charge KES 3000 per session. Couples therapy sessions are available for KES 5000 per pair for physical sessions. Please contact us for more information on pricing and to schedule your session.",
      },
      {
        title:
          "Do you offer Employee Assistance Programs (EAPs) for companies?",
        content:
          "Yes, we offer Employee Assistance Programs (EAPs) to support the mental health and well- being of employees in organizations. Our EAP services provide confidential counseling and support for employees facing personal or work-related challenges, helping them manage stress, improve work-life balance, and enhance overall wellness and productivity. Employers can contact us to learn more about our EAP offerings and how they can support their employees' mental health needs.",
      },
      {
        title: "Do you accept insurance?",
        content:
          "We currently do not accept insurance directly (we are tirelessly working on it), but we can provide you with a superbill that you can submit to your insurance company for potential reimbursement. We recommend contacting your insurance provider to verify coverage for mental health services.",
      },
    ],
  };

  const handleFaqClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="faq" id="faq">
      <div className="container">
        <div className="section-tag">
          <SubHeader title={"FAQs"} subheader={"Frequently Asked Questions."} />
        </div>
        {data.rows.map((item, index) => (
          <div className="faq-item" key={index}>
            <div
              className={`faq-question ${
                index === activeIndex ? "active" : ""
              }`}
              onClick={() => handleFaqClick(index)}
            >
              {item.title}
            </div>
            <div
              className={`faq-answer ${index === activeIndex ? "active" : ""}`}
            >
              <div className="faq-answer-content">{item.content}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
